import { LogOut } from 'lucide-react';
import { Button } from 'antd';
import { tokenManager } from '../api/tokenManager';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../store/appStore';

type ProfileProps = {
  collapsed: boolean;
};

const Profile = ({ collapsed }: ProfileProps) => {
  // const [user] = useState({
  //   name: 'John Doe',
  //   role: 'Admin',
  // });
  const profile = useAppStore((state) => state.profile);

  const navigate = useNavigate();

  const getInitials = (name: string) => {
    if (!name) return '';
    const words = name.split(' ');
    return words.length === 1
      ? words[0].charAt(0).toUpperCase()
      : (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };

  const handleSignOut = async () => {
    await tokenManager.clearAll();
    navigate('/login');
  };

  const initials = getInitials(profile.user.name);

  return (
    <div
      className={`flex flex-col items-center bg-white rounded-lg shadow-md mx-auto transition-all duration-300 ${collapsed ? 'p-2' : 'p-4'} !pb-4`}
    >
      {/* Avatar */}
      <div className="flex-shrink-0">
        <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-white font-bold text-sm">
          {initials}
        </div>
      </div>

      {/* Name and Role */}
      {!collapsed && (
        <>
          <h2 className="mt-2 text-base font-semibold text-primary">{profile.user.name}</h2>
          <p className="text-sm text-secondary">{profile.user.email ? profile.user.email : ''}</p>
        </>
      )}

      {/* Sign out button */}
      <Button
        onClick={handleSignOut}
        className={`mt-2 flex items-center justify-center gap-1  transition-all duration-300 ${collapsed ? 'px-1 py-1' : 'px-3 py-2'}`}
      >
        <LogOut size={18} className="text-primary" />
        {!collapsed && <span className="text-sm font-medium text-primary">Sign out</span>}
      </Button>
    </div>
  );
};

export default Profile;
